// A file's or a folder's icon, for the workbench's tree and its editor's
// tabs (byj-1wv.51.23): a page coloured by what it holds, told at a glance —
// code, data, writing, the web's, a picture — or a folder, open or shut.
// It says nothing to a screen reader; the name beside it does.

const kinds: Record<string, string[]> = {
  code: ["py", "js", "mjs", "cjs", "ts", "tsx", "jsx", "go", "rs", "java", "kt", "rb", "php", "c", "h", "cpp", "cc", "hpp", "cs", "swift", "clj", "cljs", "cljc", "sh", "bash", "zsh", "sql", "lua", "scala"],
  data: ["json", "yaml", "yml", "toml", "csv", "tsv", "edn", "xml", "ini", "lock"],
  doc: ["md", "markdown", "txt", "rst", "adoc"],
  web: ["html", "htm", "css", "scss", "sass", "less", "svg", "vue", "svelte"],
  image: ["png", "jpg", "jpeg", "gif", "webp", "ico"],
};

/** What a file holds, by its name's extension: one of `kinds`, or "other". */
export function fileKind(name: string): string {
  const dot = name.lastIndexOf(".");
  const ext = dot > 0 ? name.slice(dot + 1).toLowerCase() : "";
  for (const [k, exts] of Object.entries(kinds)) if (exts.includes(ext)) return k;
  return "other";
}

export function FileIcon({ name, dir = false, open = false }: { name: string; dir?: boolean; open?: boolean }) {
  if (dir) {
    return (
      <svg className="file-icon file-icon-dir" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true">
        {open ? (
          <path d="M1.75 3.5a1 1 0 0 1 1-1h3.1l1.4 1.5h5.5a1 1 0 0 1 1 1V6H4.4a1 1 0 0 0-.95.68L1.75 12V3.5ZM3.45 6.68A1 1 0 0 1 4.4 6h10.1l-1.9 6.32a1 1 0 0 1-.95.68H1.75Z" fill="currentColor" fillOpacity="0.2" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
        ) : (
          <path d="M1.75 4a1 1 0 0 1 1-1h3.1l1.4 1.5h6a1 1 0 0 1 1 1v6.75a1 1 0 0 1-1 1H2.75a1 1 0 0 1-1-1Z" fill="currentColor" fillOpacity="0.2" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
        )}
      </svg>
    );
  }
  return (
    <svg className={`file-icon file-icon-${fileKind(name)}`} viewBox="0 0 16 16" width="16" height="16" aria-hidden="true">
      <path d="M9 1.75H4.25a1 1 0 0 0-1 1v10.5a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5.5Z" fill="currentColor" fillOpacity="0.2" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
      <path d="M9 1.75V5.5h3.75" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
    </svg>
  );
}
